const body = JSON.stringify({
  cmode: "fixednum",
  differentiate: false,
  numquestions: data.numquestions,
  interleave: false,
  recipients: data.luser?.id ? { uids: [data.luser.id] } : {},
  skillselection: {
    skids: [],
    ssids: data.ssids,
  },
  type: "kc",
  intent: "INDEPENDENT_PRACTICE",
});

fetch("/api/tasks/tasks", {
  method: "POST",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body,
})
  .then(async (res) => {
    if (!res.ok) {
      // Actually include the real error message in the error.php output, rather than just "TypeError: can't access property 0"
      const text = await res.text();
      throw new Error(text);
    }
    return res.json();
  })
  .then(({ aaids }) => {
    window.location = `/do-question.php?aaid=${aaids[0]}`;
  })
  .catch((error) => {
    const errorMessage = `Sorry. There was an error loading this practice session: (${error})`;
    window.location = `/error.php?message=${errorMessage}`;
  });
